<template>
  <div class="content vacancies">

    <!-- Header -->
    <div class="content-header">
      <div class="content-header-inner">
        <div class="center-md center-xs">
          <img src="/assets/static/vacancies/team/team.png"
               srcset="assets/static/vacancies/team/team@2x.png,
                       assets/static/vacancies/team/team@3x.png"
               class="content-header-image"
               alt="photo"
               width="308"
               height="325"
               loading="eager"
               fetchpriority="high"
          >
        </div>
        <div class="content-header-side">
          <div class="content-header-side-text"> Реєстрація в якості курє'ра на “Korzyna“. </div>
          <button class="content-header-side-btn" @click="showRegisterModal"> Зареєструвати заявку </button>
          <div v-if="isSuccess" class="content-header-side-text-green" > Дякуємо за реєстрацію. Очікуйте на дзвінок оператора та подальші вказівки. </div>


        </div>
      </div>
    </div>
    <!---->
    <courier-register />
  </div>
</template>

<script>
import CourierRegister from './Register'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CourierRegister
  },
  mounted () {
    if (!this.selectedLocation) {
      this.selectedLocation = this.$store.getters['locations/getActiveLocation'] ? this.$store.getters['locations/getActiveLocation'].code : this.locations[0].code
    }
  },
  data () {
    return {
      selectedLocation: '',
      isSuccess: false
    }
  },
  computed: {
    ...mapGetters({
      locations: 'locations/getLocations'
    }),
    location() {
      let location = this.locations.find((p) => p.code === this.selectedLocation)
      return location ? location : {}
    },
  },
  methods: {
    ...mapActions({
      sendApplicationEmail: 'vacancies/sendApplicationEmail'
    }),

    closeCourierRegisterModal (payload) {
      if (payload.result) {
        this.isSuccess = true
      }
      this.$bus.$emit('modal-hide', 'modal-courier-register')
    },

    showRegisterModal () {
      this.isSuccess = false
      this.$bus.$emit('modal-show', 'modal-courier-register')
    }
  }
}
</script>
<style lang="scss" scoped>
  .content {
    width: 100%;

    /* Header */
    &-header {
      width: 100%;
      margin-bottom: 30px;

      background: #f5f5f5;

      display: flex;
      justify-content: center;

      &-inner {
        width: 1140px;
        padding: 30px 0;

        display: flex;

        @media only screen and (max-width: 1700px) {
          width: 100%;
          display: block;
          padding: 30px;
        }

        @media only screen and (max-width: 991px) {
          width: 722px;
        }

        @media only screen and (max-width: 768px) {
          width: 560px;
        }

        @media only screen and (max-width: 576px) {
          width: 100%;
          padding: 20px;

          flex-direction: column;
          align-items: center;
        }
      }

      &-image {
        width: 308px;
        height: 325px;

        padding-left: 90px;
        @media only screen and (max-width: 1700px) {
          padding-left: 0;
        }
        @media only screen and (max-width: 991px) {
          padding-left: 0;
        }

        @media only screen and (max-width: 768px) {
          width: 277px;
          height: 292px;
        }

        @media only screen and (max-width: 320px) {
          width: 100%;
          height: 100%;
        }
      }

      &-side {
        width: 100%;
        padding: 30px;
        margin-left: 20px;

        display: flex;
        flex-direction: column;
        @media only screen and (max-width: 1700px) {
          width: 100%;
          padding: 0;
          margin-left: 0;
        }
        @media only screen and (max-width: 991px) {
          padding-right: 0;
        }

        @media only screen and (max-width: 768px) {
          padding: 0;
        }

        @media only screen and (max-width: 576px) {
          margin-top: 20px;
          margin-left: 0;
        }

        &-text {
          width: 560px;
          margin: 0;

          color: #111;
          font-size: 18px;
          font-weight: 400;
          line-height: 26px;

          @media only screen and (max-width: 1700px) {
            width: 100%
          }

          @media only screen and (max-width: 991px) {
            width: 100%;
          }

          @media only screen and (max-width: 768px) {
            font-size: 16px;
            line-height: 20px;
          }

          &-link {
            color: #11bb2e;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }

          &-green {
            color: #11bb2e;
            margin-top: 20px;
          }
        }

        &-location {
          margin-top: 20px;

          display: flex;
          flex-direction: column;

          &-title {
            margin: 0;

            color: #111;
            font-size: 16px;
            font-weight: 600;
          }

          &-listbox {
            margin-top: 10px;
            padding: 0 10px;
            width: 240px;

            position: relative;
            flex: 1;

            color: #000;
            font-size: 14px;

            background-image: url('../../../../assets/static/vacancies/arrow-listbox.svg');
            background-position: 220px center;
            background-size: 10px;
            background-repeat: no-repeat;

            background-color: #fff;
            border: none;
            border-radius: 5px;
            outline: none;
            appearance: none;

            @media only screen and (max-width: 1700px) {
              background-position: 750px center;
            }
            @media only screen and (max-width: 1200px) {
              background-position: 550px center;
            }

            @media only screen and (max-width: 991px) {
              background-position: 610px center;
            }

            @media only screen and (max-width: 768px) {
              background-position: 460px center;
            }

            @media only screen and (max-width: 576px) {
              background-size: 0;
            }
          }
        }

        &-btn {
          width: 210px;
          margin-top: 20px;
          padding: 7px 22px 7px 40px;
          position: relative;

          color: #fff;
          font-size: 14px;
          font-weight: 600;

          background-color: #11bb2e;
          border-radius: 25px;
          border: none;
          outline: none;

          transition: .2s;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, .8);
          }

          &.isActive:before {
            transform: rotate(180deg);
          }

          &:before {
            width: 30px;
            height: 30px;
            margin: auto;

            position: absolute;
            top: 0;
            left: -2px;
            bottom: 0;
            content: '';

            background-image: url('../../../../assets/static/vacancies/arrow.png');
            background-position: center;
            background-size: 16px;
            background-repeat: no-repeat;

            background-color: #fff;
            border-radius: 50%;

            transition: .2s;
          }
        }
      }
    }
    /* --- */

    /* Modal */
    &-modal {
      width: 100%;
      height: 100%;
      margin: auto;

      display: none;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;

      background: transparent;
      z-index: 999;

      transition: .2s;

      &.isExist {
        display: flex;
      }

      &.isActive {
        background: rgba(0, 0, 0, .2);
      }

      &-block {
        width: 500px;
        display: none;

        background: #fff;
        border-radius: 10px;
        opacity: 0;

        transform: translateY(-150px);
        transition: .2s;

        @media only screen and (max-width: 576px) {
          width: 100%;
          height: 100%;

          border-radius: 0;
        }

        &.isExist {
          display: block;
        }

        &.isActive {
          opacity: 1;
          transform: translateY(0);
        }

        &-inner {
          padding: 20px;
          position: relative;

          display: flex;
          flex-direction: column;
          align-items: center;
        }

        &-image {
          width: 435px;
          height: 168px;
        }

        &-title {
          margin: 21px 0 0 0;

          color: #111;
          font-size: 21px;
          font-weight: 400;
        }

        &-text {
          margin: 10px 0 0 0;

          color: #111;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
        }

        &-btn {
          margin-top: 20px;
          padding: 12px 28px;

          color: #fff;
          font-size: 12px;
          font-weight: 600;

          background-color: #11bb2e;
          border-radius: 5px;
          border: none;
          outline: none;

          transition: .2s;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, .8);
          }
        }

        &-close {
          width: 20px;
          height: 20px;
          margin: auto;

          position: absolute;
          top: 20px;
          right: 20px;

          background-image: url('../../../../assets/static/vacancies/close.png');
          background-position: center;
          background-size: 17px;
          background-repeat: no-repeat;

          background-color: transparent;
          border: none;
          outline: none;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    /* --- */
  }
</style>
